import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal from './components/modal/modal';

function EverydollarPremiumFeaturesModalLauncher({ ctaLink }) {
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const handleKeyPress = (e) => {
    if (e.key !== 'Tab') {
      toggleModal();
    }
  };

  return (
    <>
      <div
        data-testid="clickable_launcher"
        onClick={toggleModal}
        onKeyDown={handleKeyPress}
        role="button"
        tabIndex="0"
      >
        Upgrade to Premium
      </div>
      <Modal
        ariaHideApp={false}
        isCentered={true}
        width="LG"
        isOpen={modalOpen}
        onRequestClose={toggleModal}
        shouldCloseOnOverlayClick={true}
      >
        <div className="MktModalContent" data-testid="modal_content">
          <div>
            <a href={ctaLink}>
              <img
                src="https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/marketing/2022/everydollar-expiration/every-dollar-price-comparison.png"
                alt="EveryDollar premium feature list"
              ></img>
            </a>
          </div>
          <div className="MktCtaContainer">
            <a
              data-testid="cta_link"
              href={ctaLink}
              className="w-full sm:w-auto rds-Button rds-Button--large"
            >
              Keep Premium Features
            </a>
          </div>
        </div>
      </Modal>
    </>
  );
}
EverydollarPremiumFeaturesModalLauncher.propTypes = {
  ctaLink: PropTypes.string
};
export default EverydollarPremiumFeaturesModalLauncher;
